import { Lightning } from '@lightningjs/sdk';
import { ScreenSize } from '../../api/ScreenSize';
import { Theme } from '../../config/theme';
import { SelectOptionList } from './SelectOptionList';

export class SelectOptionDialog extends Lightning.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      w: w => w,
      h: h => h,
      color: Theme.Colors.Option.Background.Page,
      rect: true,
      Options: {
        x: ScreenSize.w * 0.5,
        y: 0,
        mountX: 0.5,
        type: SelectOptionList,
      },
    };
  }

  _init() {
    this.tag('Options').data = { title: this._params.title, options: this._params.options, callback: this._success };
  }

  set params(params) {
    this._params = params;
    this._success = params.onSuccess;
    this._cancelled = params.onCancelled;
    this.tag('Options').centerFocusedItem = params.centerFocusedItem;
  }

  _getFocused() {
    return this.tag('Options');
  }

  _handleBack() {
    this._cancelled && this._cancelled();
    this.fireAncestors('$closeDialog');
  }
}
